import Vue from 'vue'
import {GridView} from "~/components";
import { BOverlay } from 'bootstrap-vue'

/**
 * You can register global components here and use them as a plugin in your main Vue instance
 */

const GlobalComponents = {
  install(Vue) {
    Vue.component('grid-view', GridView);
    Vue.component('b-overlay', BOverlay);
  }
};
Vue.use(GlobalComponents);

export default GlobalComponents;







